function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#f5f5f5"
    },
    cx: 249.86,
    cy: 362.362,
    rx: 224.226,
    ry: 124.15,
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 499.72 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6"
    },
    d: "M451.688 343.148 326.696 415.35c-.927.535-2.431.535-3.358 0L143.117 311.3c-.927-.535-.927-1.404 0-1.939l124.992-72.202c.927-.536 2.431-.536 3.358 0l180.22 104.05c.928.536.928 1.404.001 1.939z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#e6e6e6"
    },
    cx: 161.23,
    cy: 412.394,
    rx: 75.083,
    ry: 43.349
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#e6e6e6"
    },
    cx: 252.653,
    cy: 362.135,
    rx: 59.1,
    ry: 34.121
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#e6e6e6"
    },
    cx: 384.088,
    cy: 407.865,
    rx: 37.097,
    ry: 21.418
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M329.42 286.365v110.944c0 .714-.501 1.582-1.119 1.939l-2.381 1.374c-.618.357-1.621.357-2.239 0l-2.38-1.374c-.618-.357-1.119-1.225-1.119-1.939V286.365c0-.714.501-1.003 1.119-.646l2.381 1.374c.618.357 1.621.357 2.239 0l2.381-1.374c.617-.358 1.118-.068 1.118.646z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "m323.681 400.621-2.38-1.374c-.618-.357-1.119-1.225-1.119-1.939V286.365c0-.714.501-1.003 1.119-.646l2.381 1.374c.618.357 1.119 1.225 1.119 1.939v110.944c-.001.713-.502 1.002-1.12.645z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M430.934 227.721v110.944c0 .714-.501 1.582-1.12 1.939l-2.381 1.374c-.618.357-1.621.357-2.239 0l-2.38-1.374c-.618-.357-1.119-1.225-1.119-1.939V227.721c0-.714.501-1.003 1.12-.646l2.381 1.374c.618.357 1.621.357 2.239 0l2.381-1.374c.616-.358 1.118-.068 1.118.646z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "m425.194 341.977-2.38-1.374c-.618-.357-1.119-1.225-1.119-1.939V227.721c0-.714.501-1.003 1.12-.646l2.381 1.374c.618.357 1.119 1.225 1.119 1.939v110.944c-.002.713-.503 1.002-1.121.645z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M192.708 207.473v110.944c0 .714-.501 1.582-1.119 1.939l-2.381 1.374c-.618.357-1.621.357-2.239 0l-2.38-1.374c-.618-.357-1.12-1.225-1.12-1.939V207.473c0-.714.501-1.003 1.12-.646l2.381 1.374c.618.357 1.621.357 2.239 0l2.381-1.374c.617-.358 1.118-.068 1.118.646z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "m186.968 321.729-2.38-1.374c-.618-.357-1.12-1.225-1.12-1.939V207.473c0-.714.501-1.003 1.12-.646l2.381 1.374c.618.357 1.119 1.225 1.119 1.939v110.944c0 .713-.501 1.002-1.12.645z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M453.021 235.612v-.812c0-1.3-.912-2.88-2.038-3.529L271.968 128.017c-1.125-.65-2.95-.65-4.075 0l-110.127 63.604c-1.125.65-2.038 2.23-2.038 3.529v.812c0 1.299.912 2.879 2.038 3.529l179.015 103.253c1.125.65 2.95.65 4.075 0l110.127-63.603c1.125-.649 2.038-2.229 2.038-3.529z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6
    },
    d: "M453.021 235.612v-.812c0-1.3-.912-2.88-2.038-3.529L271.968 128.017c-1.125-.65-2.95-.65-4.075 0l-110.127 63.604c-1.125.65-2.038 2.23-2.038 3.529v.812c0 1.299.912 2.879 2.038 3.529l179.015 103.253c1.125.65 2.95.65 4.075 0l110.127-63.603c1.125-.649 2.038-2.229 2.038-3.529z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M338.819 297.718v5.521c.737 0 1.474-.173 2.039-.486l110.122-63.606c1.129-.659 2.039-2.228 2.039-3.529v-.816c0-1.145-.706-2.525-1.663-3.263.737.628.612 1.506-.376 2.086l-110.122 63.606c-.565.33-1.302.487-2.039.487z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M338.819 297.718v5.521c.737 0 1.474-.173 2.039-.486l110.122-63.606c1.129-.659 2.039-2.228 2.039-3.529v-.816c0-1.145-.706-2.525-1.663-3.263.737.628.612 1.506-.376 2.086l-110.122 63.606c-.565.33-1.302.487-2.039.487z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m450.983 233.624-110.127 63.603c-1.125.65-2.95.65-4.075 0L157.766 193.974c-1.125-.65-1.125-1.703 0-2.353l110.127-63.604c1.125-.65 2.95-.65 4.075 0L450.983 231.27c1.126.65 1.126 1.704 0 2.354z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "m450.983 233.624-110.127 63.603c-1.125.65-2.95.65-4.075 0L157.766 193.974c-1.125-.65-1.125-1.703 0-2.353l110.127-63.604c1.125-.65 2.95-.65 4.075 0L450.983 231.27c1.126.65 1.126 1.704 0 2.354z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "m325.29 232.236-26.092 15.107c-.807.467-2.116.468-2.924.003l-77.084-44.444c-.808-.466-.809-1.222-.002-1.689l26.092-15.107c.807-.467 2.116-.468 2.924-.003l77.084 44.444c.808.465.809 1.221.002 1.689z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M220.77 198.534c0-.306.202-.611.605-.845l24.513-14.15c.807-.466 2.117-.466 2.924.001l74.797 43.255c.403.233.605.539.605.844v2.57c.001.306-.202.612-.607.844l-24.5 14.149c-.808.465-2.118.464-2.926-.003l-74.805-43.186c-.402-.232-.604-.536-.605-.841-.003-.306-.001-2.333-.001-2.638z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "m299.106 242.566 24.5-14.085c.808-.465.809-1.22.002-1.686l-74.796-43.255c-.807-.467-2.116-.467-2.924-.001l-24.513 14.15c-.807.466-.807 1.222 0 1.688l74.805 43.186c.808.466 2.118.467 2.926.003z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M297.738 242.913v2.628c.495-.011.99-.124 1.373-.337l24.492-14.148c.405-.236.608-.54.608-.844v-2.577c0 .304-.203.608-.608.844l-24.492 14.092c-.383.213-.878.331-1.373.342z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M225.309 198.722c0-.015.011-.027.017-.03l2.425-1.4 3.292 1.9-2.44 1.447-3.288-1.898zm3.798-2.192a.04.04 0 0 1 .017-.031l2.426-1.401 2.585 1.492-2.442 1.448-2.582-1.491zm.8 4.847c0-.016.012-.027.017-.031l2.427-1.401 2.583 1.492-2.442 1.448-2.58-1.49zm2.998-7.04a.04.04 0 0 1 .017-.032l2.425-1.4 4.175 2.411-2.44 1.449-4.173-2.41zm.094 4.439c0-.016.011-.028.017-.031l2.426-1.401 2.054 1.185-2.443 1.449-2.05-1.184zm.799 4.847a.04.04 0 0 1 .017-.031l2.425-1.4 2.585 1.492-2.442 1.447-2.58-1.49zm2.559-2.906c0-.016.013-.029.019-.033l2.425-1.4 2.052 1.186-2.441 1.448-2.05-1.184zm.346-8.572c0-.017.011-.029.017-.032l2.426-1.4 3.292 1.901-2.443 1.448-3.288-1.899zm.986 13.725c0-.016.011-.028.017-.031l2.425-1.4 18.678 10.783-2.444 1.448-18.673-10.782zm.699-8.367a.04.04 0 0 1 .017-.032l2.425-1.4 2.052 1.186-2.441 1.448-2.05-1.184zm1.331 5.153a.04.04 0 0 1 .017-.032l2.425-1.4 2.052 1.186-2.441 1.447-2.05-1.184zm.782-12.704c0-.017.011-.029.017-.032l2.425-1.401 2.052 1.186-2.441 1.449-2.05-1.184zm.8 4.847a.04.04 0 0 1 .017-.031l2.425-1.401 2.054 1.186-2.443 1.448-2.05-1.184zm.447 4.644a.04.04 0 0 1 .017-.032l2.426-1.4 2.052 1.186-2.443 1.449-2.048-1.184zm1.331 5.153c0-.017.012-.029.017-.033l2.426-1.4 2.052 1.186-2.443 1.448-2.049-1.184zm.783-12.704c0-.017.012-.029.017-.033l2.425-1.4 2.052 1.185-2.441 1.448-2.05-1.184zm.799 4.847c0-.016.011-.028.017-.031l2.425-1.401 2.054 1.185-2.443 1.448-2.05-1.184zm.446 4.644c0-.016.013-.028.019-.032l2.425-1.401 2.052 1.186-2.443 1.449-2.049-1.184zm.003-14.092c0-.016.012-.029.017-.032l2.426-1.401 2.583 1.493-2.443 1.448-2.579-1.491zm1.329 19.245c0-.016.011-.028.017-.032l2.425-1.4 2.052 1.186-2.441 1.448-2.05-1.184zm.783-12.704c0-.017.012-.029.017-.033l2.426-1.4 2.052 1.185-2.441 1.448-2.05-1.184zm.799 4.848c0-.016.012-.029.017-.032l2.425-1.401 2.054 1.186-2.443 1.448-2.05-1.184zm.448 4.643c0-.016.011-.028.017-.031l2.425-1.401 2.052 1.186-2.443 1.448-2.048-1.184zm1.331 5.153c0-.016.012-.029.017-.032l2.426-1.4 2.052 1.186-2.441 1.448-2.05-1.184zm.662-18.095a.04.04 0 0 1 .017-.031l2.427-1.401 2.052 1.186-2.443 1.448-2.05-1.184zm.118 5.392c0-.016.013-.029.019-.033l2.425-1.4 2.052 1.186-2.443 1.449-2.048-1.184zm.802 4.847c0-.017.012-.028.017-.032l2.426-1.401 2.054 1.186-2.443 1.448-2.05-1.184zm.445 4.643c0-.017.013-.029.019-.033l2.425-1.4 2.052 1.186-2.442 1.448-2.049-1.184zm1.331 5.154c0-.016.013-.028.019-.032l2.426-1.401 2.052 1.186-2.442 1.448-2.049-1.184zm.664-18.095c0-.017.011-.029.017-.033l2.425-1.399 2.054 1.185-2.442 1.448-2.05-1.184zm.118 5.389c0-.016.012-.027.017-.031l2.427-1.401 2.052 1.186-2.443 1.448-2.048-1.184zm.802 4.849a.04.04 0 0 1 .017-.032l2.426-1.4 2.054 1.185-2.443 1.448-2.05-1.184zm.445 4.643c0-.016.011-.028.017-.031l2.427-1.401 2.052 1.186-2.443 1.448-2.049-1.184zm1.333 5.153c0-.016.011-.028.017-.031l2.425-1.401 2.052 1.186-2.441 1.447-2.051-1.184zm.663-18.095c0-.016.012-.029.017-.032l2.425-1.399 2.054 1.185-2.443 1.448-2.05-1.184zm.119 5.391c0-.017.012-.029.017-.033l2.426-1.4 2.052 1.186-2.442 1.448-2.049-1.184zm.372 17.756a.04.04 0 0 1 .017-.032l2.425-1.401 2.583 1.492-2.443 1.449-2.58-1.49zm.428-12.908c0-.016.012-.028.017-.032l2.425-1.401 2.054 1.186-2.443 1.448-2.051-1.184zm.446 4.642c0-.016.011-.027.017-.031l2.427-1.401 2.052 1.186-2.443 1.448-2.049-1.184zm1.332 5.154c0-.016.012-.029.017-.032l2.425-1.4 2.052 1.186-2.443 1.448-2.048-1.184zm.663-18.095a.04.04 0 0 1 .017-.031l2.426-1.401 2.054 1.185-2.443 1.448-2.051-1.184zm.118 5.392c0-.017.013-.029.019-.033l2.426-1.4 2.052 1.186-2.443 1.448-2.049-1.184zm.801 4.847c0-.016.012-.029.017-.032l2.425-1.401 2.054 1.186-2.443 1.448-2.05-1.184zm.101 13.215c0-.016.013-.029.019-.033l2.426-1.4 2.584 1.492-2.441 1.449-2.582-1.491zm.345-8.572c0-.016.013-.029.019-.033l2.425-1.4 2.052 1.186-2.442 1.448-2.049-1.184zm1.331 5.154c0-.017.013-.029.019-.033l2.426-1.4 2.052 1.186-2.441 1.447-2.05-1.183zm.782-12.705a.04.04 0 0 1 .017-.031l2.427-1.401 2.052 1.185-2.443 1.449-2.048-1.184zm.802 4.847c0-.016.011-.028.017-.031l2.426-1.401 2.052 1.186-2.441 1.447-2.05-1.184zm.445 4.644c0-.016.011-.028.017-.031l2.427-1.401 2.052 1.186-2.443 1.448-2.049-1.184zm.097-14.038c0-.016.011-.028.017-.031l2.425-1.401 2.054 1.186-2.443 1.448-2.05-1.184zm.09 22.916c0-.017.011-.029.017-.032l2.426-1.4 2.585 1.492-2.443 1.448-2.582-1.49zm1.144-3.726c0-.016.012-.027.017-.03l2.427-1.401 2.052 1.186-2.443 1.448-2.048-1.184zm.783-12.703c0-.018.015-.03.019-.033l2.424-1.399 2.054 1.185-2.443 1.449-2.049-1.184zm.801 4.847c0-.016.011-.028.017-.031l2.425-1.401 2.054 1.186-2.443 1.448-2.05-1.184zm.445 4.643c0-.016.011-.028.017-.031l2.427-1.401 2.052 1.186-2.443 1.448-2.049-1.184zm.097-14.037a.04.04 0 0 1 .017-.031l2.425-1.401 2.055 1.186-2.443 1.448-2.05-1.184zm.621 23.222a.04.04 0 0 1 .017-.032l2.425-1.401 3.292 1.901-2.443 1.448-3.288-1.898zm.613-4.03c0-.016.013-.028.019-.032l2.425-1.401 6.475 3.738-2.443 1.448-6.471-3.737zm.783-12.706c0-.016.012-.028.017-.032l2.427-1.4 2.052 1.186-2.443 1.448-2.049-1.184zm.801 4.849a.04.04 0 0 1 .017-.032l2.426-1.401 2.054 1.186-2.443 1.448-2.05-1.184zm.446 4.642c0-.015.012-.027.017-.031l2.427-1.401 2.052 1.186-2.443 1.448-2.049-1.184zm.097-14.036a.04.04 0 0 1 .017-.032l2.426-1.401 2.054 1.186-2.442 1.448-2.051-1.184zm2.016 6.485c0-.016.012-.028.017-.032l2.427-1.4 2.052 1.186-2.443 1.448-2.048-1.184zm.548 17.859c0-.015.011-.027.017-.03l2.427-1.402 2.052 1.186-2.443 1.448-2.049-1.184zm.254-13.01c0-.017.011-.029.017-.032l2.426-1.401 2.052 1.186-2.441 1.447-2.05-1.184zm.445 4.642c0-.015.011-.027.017-.03l2.427-1.402 1.875 1.083c.132.076.352.121.592.121.251 0 .478-.046.621-.129l3.185-1.84 2.406 1.391-6.237 3.641-4.881-2.818zm.097-14.037c0-.016.011-.028.017-.031l2.425-1.401 2.054 1.186-2.443 1.448-2.05-1.184zm2.016 6.487c0-.016.011-.028.017-.031l2.425-1.401 2.054 1.186-2.443 1.448-2.049-1.184zm.55 17.858a.04.04 0 0 1 .017-.032l2.425-1.401 2.052 1.186-2.443 1.448-2.049-1.184zm.252-13.01a.04.04 0 0 1 .017-.032l2.426-1.401 2.052 1.186-2.443 1.448-2.048-1.184zm2.004-8.55c0-.016.012-.029.017-.032l2.426-1.401 2.054 1.186-2.443 1.448-2.05-1.184zm.554 5.641c0-.016.011-.028.017-.032l2.425-1.399 2.054 1.186-2.443 1.448-2.049-1.184zm.549 17.859c0-.016.012-.029.019-.033l2.426-1.4 2.052 1.186-2.443 1.448-2.049-1.184zm.437-4.133c0-.016.011-.029.017-.033l2.427-1.4 2.052 1.186-2.443 1.448-2.051-1.184zm1.821-17.427a.04.04 0 0 1 .017-.032l2.426-1.401 2.052 1.186-2.441 1.448-2.051-1.184zm.553 5.641c0-.016.011-.028.017-.032l2.426-1.399 3.646 2.104-2.443 1.448-3.64-2.103zm1.257 18.267c0-.016.011-.028.017-.031l2.426-1.401 5.414 3.126-2.443 1.448-5.411-3.124zm.605-12.806a.04.04 0 0 1 .017-.032l2.425-1.4 2.054 1.186-2.44 1.448-2.052-1.184zm.945-9.162c0-.017.011-.029.017-.032l2.425-1.401 2.052 1.186-2.441 1.448-2.05-1.184zm2.248 19.776c0-.016.011-.028.017-.032l2.425-1.4 2.054 1.186-2.441 1.448-2.052-1.184zm.168-8.674c0-.017.011-.029.017-.032l2.425-1.399 2.054 1.185-2.443 1.449-2.05-1.184zm.437-4.133c0-.016.012-.029.017-.032l2.426-1.401 2.054 1.186-2.442 1.448-2.051-1.183zm.507-5.029c0-.016.012-.029.017-.032l2.425-1.401 2.052 1.186-2.441 1.448-2.05-1.184zm1.81 23.908a.04.04 0 0 1 .017-.032l2.425-1.399 2.055 1.185-2.443 1.448-2.05-1.184zm.438-4.132a.04.04 0 0 1 .017-.032l2.426-1.4 2.054 1.185-2.443 1.448-2.05-1.184zm.168-8.674a.04.04 0 0 1 .017-.032l2.425-1.4 2.054 1.186-2.443 1.448-2.051-1.184zm.27 4.541a.04.04 0 0 1 .017-.032l2.426-1.401 2.052 1.186-2.441 1.448-2.05-1.184zm.168-8.674c0-.016.011-.028.017-.032l2.425-1.4 2.054 1.186-2.443 1.448-2.05-1.184zm1.249-4.6c0-.016.012-.029.017-.032l2.425-1.401 2.054 1.186-2.443 1.448-2.05-1.184zm1.068 23.479c0-.017.011-.029.017-.033l6.224-3.592 2.054 1.186-6.239 3.642-2.052-1.185zm.438-4.132a.04.04 0 0 1 .017-.032l2.425-1.4 2.054 1.186-2.443 1.449-2.051-1.184zm.438-4.133a.04.04 0 0 1 .017-.032l2.425-1.401 2.052 1.186-2.441 1.448-2.05-1.184zm.167-8.673a.04.04 0 0 1 .017-.032l2.425-1.4 2.054 1.185-2.443 1.448-2.05-1.184zm.269 4.541c0-.016.011-.027.017-.03l2.427-1.403 2.052 1.186-2.442 1.448-2.049-1.184zm.98-9.142c0-.016.012-.029.017-.032l2.426-1.401 2.054 1.186-2.443 1.448-2.05-1.184zm1.944 15.214c0-.016.012-.029.017-.032l2.425-1.401 2.052 1.186-2.441 1.449-2.05-1.184zm.436-4.132c0-.016.012-.027.017-.031l2.427-1.403 2.052 1.186-2.443 1.448-2.048-1.184zm.437-4.134a.04.04 0 0 1 .017-.031l2.426-1.401 2.054 1.186-2.443 1.448-2.049-1.184zm.543-5.009a.04.04 0 0 1 .017-.032l2.426-1.401 2.054 1.186-2.443 1.448-2.051-1.184zm1.944 15.215c0-.016.012-.029.017-.032l6.224-3.593 2.052 1.186-6.237 3.642-2.052-1.185zm.436-4.133c0-.015.011-.027.017-.03l2.427-1.403 2.052 1.186-2.443 1.448-2.049-1.184zm.438-4.133c0-.015.011-.027.017-.03l2.425-1.402 2.054 1.185-2.443 1.448-2.048-1.184zm2.225-5.163a.04.04 0 0 1 .017-.032l1.03-.608 2.054 1.185-1.055.651-2.043-1.179zm1.135 7.104a.04.04 0 0 1 .017-.031l2.426-1.401 2.054 1.186-2.443 1.448-2.048-1.184zm2.226-5.164c0-.016.012-.029.017-.032l1.03-.607 2.054 1.186-1.055.65-2.043-1.178zm1.134 7.103a.04.04 0 0 1 .017-.031l2.426-1.401 2.054 1.185-2.443 1.448-2.049-1.184zm2.226-5.163c0-.016.011-.028.017-.032l1.03-.607 2.054 1.185-1.055.651-2.043-1.179zm3.358 1.94c0-.016.013-.029.019-.033l1.03-.608 2.054 1.186-1.055.651-2.043-1.179z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "M408.534 221.916 293.77 155.657l-22.954 13.251 114.765 66.26z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6"
    },
    d: "m320.594 213.596-16.387-9.475c-1.689-.975-2.534-2.253-2.534-3.531s-.007-2.279-.007-2.279l15.419-8.752c.901-.52 1.631-1.785 1.631-2.826V166.53l28.621 16.539.001 20.203c0 1.04-.73 2.305-1.631 2.825l-12.88 7.499c-3.378 1.95-8.855 1.95-12.233 0z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0"
    },
    d: "M340.467 206.849v2.27l5.246-3.023c.895-.518 1.629-1.78 1.629-2.825V183.07l-5.453-3.146c-.113 1.385-.235 2.816-.348 4.21l3.823 2.213v15.784c0 1.045-.725 2.307-1.629 2.825z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5"
    },
    d: "M345.365 202.135c0 1.04-.73 2.305-1.631 2.825l-10.904 6.357c-3.378 1.951-8.856 1.951-12.235.001l-16.395-9.474c-3.379-1.95-3.379-5.111-.001-7.062l10.912-6.362c.901-.52 1.631-1.785 1.631-2.825v-15.786l28.622 16.539v15.787z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb"
    },
    d: "M311.789 190.341v-.002l3.322-1.918c.901-.52 1.631-1.785 1.631-2.825V169.81l28.622 16.539v15.787c0 1.04-.73 2.305-1.631 2.825l-3.265 1.885zM301.669 198.312v2.279c0 1.281.848 2.552 2.533 3.532l16.389 9.469c1.62.942 3.72 1.413 5.839 1.45v-2.27c-2.119-.028-4.219-.518-5.839-1.45l-16.389-9.479c-1.685-.969-2.533-2.25-2.533-3.531z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "M391.32 223.93c-1.056.61-2.826.577-3.952-.073L276.68 159.952c-1.126-.65-2.038-2.231-2.038-3.531V59.537c0-1.3.856-2.849 1.913-3.459 1.056-.61 2.826-.577 3.952.073l110.687 63.905c1.126.65 2.039 2.231 2.039 3.532l.001 96.884c-.001 1.3-.857 2.848-1.914 3.458z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M387.368 223.855 276.68 159.95c-1.126-.65-2.039-2.231-2.039-3.532V59.534c0-1.3.913-1.827 2.039-1.177l110.686 63.905c1.126.65 2.039 2.231 2.039 3.532l.001 96.884c.001 1.3-.912 1.827-2.038 1.177z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0"
    },
    d: "M387.668 224.259c1.13.499 2.693.48 3.654-.075 1.055-.612 1.912-2.157 1.912-3.466v-10.896l-3.824 2.213v10.896c0 1.187-.753 1.723-1.742 1.328z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M389.407 212.032v10.896c0 1.3-.913 1.827-2.039 1.177L276.68 160.201c-1.126-.65-2.039-2.231-2.039-3.532v-10.896z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m385.582 203.743-.001-76.68c0-.78-.548-1.729-1.223-2.119L279.692 64.515c-.676-.39-1.224-.074-1.224.706l-.004 76.682c0 .78.548 1.729 1.223 2.119l104.67 60.427c.678.391 1.225.075 1.225-.706z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#fff"
    },
    d: "m385.582 203.743-.001-76.68c0-.78-.548-1.729-1.223-2.119L279.692 64.515c-.676-.39-1.224-.074-1.224.706l-.004 76.682c0 .78.548 1.729 1.223 2.119l104.67 60.427c.678.391 1.225.075 1.225-.706z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "M332.026 183.07c1.057.61 1.913 2.094 1.913 3.314 0 1.22-.857 1.714-1.913 1.104-1.057-.61-1.913-2.094-1.913-3.314-.001-1.22.856-1.714 1.913-1.104z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M388.807 123.776c.367.64.593 1.366.603 2.015v86.243l3.824-2.213v-86.234c0-.65-.235-1.375-.603-2.015z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "M292.752 39.532a.788.788 0 0 1 .032-.179c-.006-.013 0-.026.006-.038a.674.674 0 0 1 .045-.173.902.902 0 0 1 .115-.25.343.343 0 0 1 .064-.102c.019-.026.032-.051.057-.071a.621.621 0 0 1 .128-.128l.013-.013a.893.893 0 0 1 .167-.096c.352-.167.807-.122 1.313.167l129.174 74.546c1.076.621 1.953 2.139 1.953 3.382v93.492l-.002.016v.427c0 .529-.296.953-.703 1.173l-.083.055c-.032.019-.064.038-.103.058a.717.717 0 0 1-.167.058 1.12 1.12 0 0 1-.25.032 1.26 1.26 0 0 1-.647-.186l-.051-.029-.004-.002-1.862-1.075-127.257-73.472c-1.076-.621-1.953-2.133-1.953-3.382V39.775c.002-.083.009-.166.015-.243z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M293.38 38.481c.352-.167.807-.122 1.313.167l129.174 74.546c1.076.621 1.953 2.139 1.953 3.382v6.379l2.492-1.46v-6.334c0-1.243-.871-2.754-1.947-3.375L297.184 37.239c-.557-.327-1.057-.333-1.415-.115a95.32 95.32 0 0 1-2.389 1.357z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M292.744 39.762c.008-1.232.877-1.731 1.95-1.112l129.175 74.545c1.078.622 1.951 2.135 1.951 3.38l-.002 6.382-133.074-76.791z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m294.694 38.65 129.172 74.545c.534.313 1.025.841 1.375 1.448l2.479-1.436c-.35-.601-.83-1.124-1.357-1.425L297.186 37.237c-.558-.325-1.056-.33-1.418-.116-.35.215-1.97 1.135-2.381 1.356.344-.165.804-.116 1.307.173z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "m428.315 121.503-.001-6.344c0-.632-.232-1.332-.594-1.951l-2.485 1.43c.362.614.583 1.307.583 1.939v6.381z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "M421.419 114.543c.609.352 1.102 1.396 1.102 2.334 0 .938-.494 1.412-1.102 1.061-.609-.352-1.103-1.396-1.103-2.334 0-.937.494-1.412 1.103-1.061zM417.449 112.247c.609.352 1.103 1.396 1.103 2.334 0 .938-.494 1.412-1.103 1.061-.609-.352-1.102-1.396-1.102-2.334 0-.937.494-1.412 1.102-1.061zM413.48 109.951c.609.352 1.102 1.396 1.102 2.334 0 .937-.493 1.412-1.102 1.061-.609-.352-1.103-1.396-1.103-2.334 0-.938.494-1.412 1.103-1.061z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#263238"
    },
    d: "m425.119 211.692.101-.057 2.057-1.19a2.068 2.068 0 0 0 1.038-1.798v-87.152l-2.494 1.462v87.551c0 .487-.247.886-.608 1.108-.019.019-.044.031-.063.044-.006.006-.006.013-.013.013z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m332.31 79.438 27.234 15.694c.383.221.693.737.693 1.151 0 .415-.311.572-.693.351L332.31 80.94c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6"
    },
    d: "m342.717 109.48 10.323 5.937c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-10.323-5.937c-.383-.221-.693-.737-.693-1.152 0-.414.31-.571.693-.35zM342.717 115.488l10.323 5.937c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-10.323-5.937c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m362.232 96.683 54.524 31.401c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-54.524-31.401c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351zM342.942 151.611l16.603 9.606c.383.221.693.736.693 1.151 0 .415-.311.572-.693.351l-16.603-9.606c-.383-.221-.693-.736-.693-1.151-.001-.415.31-.572.693-.351zM362.232 162.769l54.524 31.441c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-54.524-31.441c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351zM332.31 85.46l13.718 7.882c.383.221.693.737.693 1.151 0 .415-.311.572-.693.351l-13.718-7.882c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m332.31 85.46 13.718 7.882c.383.221.693.737.693 1.151 0 .415-.311.572-.693.351l-13.718-7.882c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m332.31 91.457 6.418 3.701c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-6.418-3.701c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m332.31 91.457 6.418 3.701c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-6.418-3.701c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m332.31 103.473 6.418 3.701c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-6.418-3.701c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m332.31 103.473 6.418 3.701c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-6.418-3.701c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m332.31 109.481 6.418 3.701c.383.221.693.737.693 1.151 0 .414-.31.572-.693.351l-6.418-3.701c-.383-.221-.693-.737-.693-1.151 0-.414.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m332.31 109.481 6.418 3.701c.383.221.693.737.693 1.151 0 .414-.31.572-.693.351l-6.418-3.701c-.383-.221-.693-.737-.693-1.151 0-.414.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m348.715 94.894 8.227 4.765c.383.221.693.737.693 1.151 0 .415-.311.572-.693.351l-8.227-4.765c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m348.715 94.894 8.227 4.765c.383.221.693.737.693 1.151 0 .415-.311.572-.693.351l-8.227-4.765c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m361.437 138.328 55.319 31.85c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-55.319-31.85c-.383-.221-.693-.736-.693-1.152 0-.414.31-.571.693-.35zM408.529 159.395l8.227 4.765c.383.221.693.737.693 1.151 0 .414-.31.572-.693.351l-8.227-4.765c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351zM350.522 125.994l55.319 31.85c.383.221.693.737.693 1.151 0 .414-.31.572-.693.351l-55.319-31.85c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m342.717 97.466 13.718 7.882c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-13.718-7.882c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m342.717 97.466 13.718 7.882c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-13.718-7.882c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m359.122 106.899 57.225 33.105c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-57.225-33.105c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m359.122 106.899 57.225 33.105c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-57.225-33.105c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6"
    },
    d: "m342.717 133.636 74.039 42.697c.383.221.693.737.693 1.151 0 .414-.31.572-.693.351l-74.039-42.697c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m332.31 127.63 6.418 3.701c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-6.418-3.701c-.383-.221-.693-.737-.693-1.152 0-.414.31-.571.693-.35z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m332.31 127.63 6.418 3.701c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-6.418-3.701c-.383-.221-.693-.737-.693-1.152 0-.414.31-.571.693-.35z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6"
    },
    d: "m342.717 139.642 74.039 42.697c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-74.039-42.696c-.383-.221-.693-.737-.693-1.151 0-.416.31-.573.693-.352z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m332.31 133.636 6.418 3.701c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-6.418-3.701c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m332.31 133.636 6.418 3.701c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-6.418-3.701c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6"
    },
    d: "m342.717 145.648 74.039 42.697c.383.221.693.737.693 1.151 0 .414-.31.572-.693.351l-74.039-42.697c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m332.31 139.642 6.418 3.701c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-6.418-3.701c-.383-.221-.693-.737-.693-1.152 0-.414.31-.571.693-.35z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m332.31 139.642 6.418 3.701c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-6.418-3.701c-.383-.221-.693-.737-.693-1.152 0-.414.31-.571.693-.35z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m322.306 73.414 3.772 2.178c.378.218.685.75.685 1.187v1.387c0 .437-.307.614-.685.396l-3.772-2.178c-.378-.218-.685-.75-.685-1.187V73.81c-.001-.437.306-.614.685-.396zM322.306 79.479l3.772 2.178c.378.218.685.75.685 1.187v1.387c0 .437-.307.614-.685.396l-3.772-2.178c-.378-.218-.685-.75-.685-1.187v-1.387c-.001-.437.306-.614.685-.396zM322.306 85.544l3.772 2.178c.378.218.685.75.685 1.187v1.387c0 .437-.307.614-.685.396l-3.772-2.178c-.378-.218-.685-.75-.685-1.187V85.94c-.001-.437.306-.615.685-.396zM322.306 91.608l3.772 2.178c.378.219.685.75.685 1.187v1.387c0 .437-.307.614-.685.396l-3.772-2.178c-.378-.219-.685-.75-.685-1.187v-1.387c-.001-.437.306-.614.685-.396zM322.306 97.673l3.772 2.178c.378.219.685.75.685 1.187v1.387c0 .437-.307.614-.685.396l-3.772-2.178c-.378-.218-.685-.75-.685-1.187v-1.387c-.001-.437.306-.614.685-.396zM322.306 103.738l3.772 2.178c.378.218.685.75.685 1.187v1.387c0 .437-.307.614-.685.396l-3.772-2.178c-.378-.218-.685-.75-.685-1.187v-1.387c-.001-.437.306-.614.685-.396zM322.306 109.803l3.772 2.178c.378.219.685.75.685 1.187v1.387c0 .437-.307.614-.685.396l-3.772-2.178c-.378-.218-.685-.75-.685-1.187v-1.387c-.001-.438.306-.615.685-.396zM322.306 115.868l3.772 2.178c.378.218.685.75.685 1.187v1.387c0 .437-.307.614-.685.396l-3.772-2.178c-.378-.218-.685-.75-.685-1.187v-1.387c-.001-.438.306-.615.685-.396zM322.306 121.932l3.772 2.178c.378.218.685.75.685 1.187v1.387c0 .437-.307.614-.685.396l-3.772-2.178c-.378-.218-.685-.75-.685-1.187v-1.387c-.001-.437.306-.614.685-.396zM322.306 127.997l3.772 2.178c.378.218.685.75.685 1.187v1.387c0 .437-.307.614-.685.396l-3.772-2.178c-.378-.218-.685-.75-.685-1.187v-1.387c-.001-.437.306-.614.685-.396zM322.306 134.062l3.772 2.178c.378.219.685.75.685 1.187v1.387c0 .437-.307.614-.685.396l-3.772-2.178c-.378-.218-.685-.75-.685-1.187v-1.387c-.001-.437.306-.615.685-.396zM322.306 140.127l3.772 2.178c.378.218.685.75.685 1.187v1.387c0 .437-.307.614-.685.396l-3.772-2.178c-.378-.218-.685-.75-.685-1.187v-1.387c-.001-.438.306-.615.685-.396z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "m297.28 53.714 20.399 11.778c.757.437 1.37 1.5 1.37 2.373V91.42c0 .874-.613 1.228-1.37.791L297.28 80.433c-.757-.437-1.37-1.5-1.37-2.374V54.505c0-.874.613-1.228 1.37-.791z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m299.174 77.063 1.878 1.086c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m299.174 77.063 1.878 1.086c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m299.174 57.773 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.736-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m299.174 57.773 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.736-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m301.813 63.146 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m301.813 63.146 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m301.813 66.994 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m301.813 66.994 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m299.174 69.344 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m299.174 69.344 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m301.813 74.721 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m301.813 74.721 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m304.316 60.744 11.469 6.622c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m304.316 60.744 11.469 6.622c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m304.316 80.034 11.469 6.622c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.736-.693-1.151 0-.416.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m304.316 80.034 11.469 6.622c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.736-.693-1.151 0-.416.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m306.956 66.117 8.829 5.107c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.736-.693-1.151-.001-.416.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m306.956 66.117 8.829 5.107c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.736-.693-1.151-.001-.416.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m306.956 69.974 8.829 5.107c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m306.956 69.974 8.829 5.107c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m304.316 72.318 11.469 6.622c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m304.316 72.318 11.469 6.622c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m306.956 77.692 8.829 5.106c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-8.829-5.106c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m306.956 77.692 8.829 5.106c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-8.829-5.106c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "m297.28 84.865 20.399 11.778c.757.437 1.37 1.5 1.37 2.373v46.545c0 .874-.613 1.228-1.37.791l-20.399-11.778c-.757-.437-1.37-1.5-1.37-2.374V85.656c0-.874.613-1.228 1.37-.791z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m299.174 88.925 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m299.174 88.925 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m301.813 94.298 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m301.813 94.298 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m301.813 98.146 1.878 1.086c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m301.813 98.146 1.878 1.086c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m299.174 100.496 1.878 1.086c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m299.174 100.496 1.878 1.086c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m304.316 91.895 11.469 6.622c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m304.316 91.895 11.469 6.622c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m306.956 97.268 8.829 5.107c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.736-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m306.956 97.268 8.829 5.107c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.736-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m306.956 101.126 8.829 5.107c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m306.956 101.126 8.829 5.107c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m304.316 103.469 11.469 6.622c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m304.316 103.469 11.469 6.622c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m301.813 105.895 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m301.813 105.895 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.736-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m301.813 109.743 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m301.813 109.743 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m306.956 108.865 8.829 5.107c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.736-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m306.956 108.865 8.829 5.107c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.736-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m306.956 112.723 8.829 5.107c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m306.956 112.723 8.829 5.107c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m299.174 119.831 1.878 1.086c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151-.001-.414.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m299.174 119.831 1.878 1.086c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151-.001-.414.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m304.316 122.805 11.469 6.622c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.737-.693-1.151 0-.414.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m304.316 122.805 11.469 6.622c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.737-.693-1.151 0-.414.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m301.813 125.231 1.878 1.086c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.152 0-.414.31-.572.693-.35z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m301.813 125.231 1.878 1.086c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.152 0-.414.31-.572.693-.35z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m301.813 129.079 1.878 1.086c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151 0-.415.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m301.813 129.079 1.878 1.086c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151 0-.415.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m306.956 128.201 8.829 5.107c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.736-.693-1.151-.001-.415.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m306.956 128.201 8.829 5.107c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.736-.693-1.151-.001-.415.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m306.956 132.059 8.829 5.107c.383.221.693.737.693 1.151 0 .414-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.736-.693-1.151-.001-.415.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m306.956 132.059 8.829 5.107c.383.221.693.737.693 1.151 0 .414-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.736-.693-1.151-.001-.415.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m301.813 113.57 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m301.813 113.57 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m299.174 115.92 1.878 1.086c.383.221.693.737.693 1.151 0 .414-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m299.174 115.92 1.878 1.086c.383.221.693.737.693 1.151 0 .414-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m306.956 116.55 8.829 5.107c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m306.956 116.55 8.829 5.107c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-8.829-5.107c-.383-.221-.693-.737-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m304.316 118.894 11.469 6.622c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.736-.693-1.151 0-.416.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m304.316 118.894 11.469 6.622c.383.221.693.736.693 1.151 0 .415-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.736-.693-1.151 0-.416.31-.573.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m299.174 131.482 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.736-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m299.174 131.482 1.878 1.086c.383.221.693.737.693 1.151 0 .415-.31.572-.693.351l-1.878-1.086c-.383-.221-.693-.736-.693-1.151-.001-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m304.316 134.455 11.469 6.622c.383.221.693.737.693 1.151 0 .414-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#fff"
    },
    d: "m304.316 134.455 11.469 6.622c.383.221.693.737.693 1.151 0 .414-.31.572-.693.351l-11.469-6.622c-.383-.221-.693-.737-.693-1.151 0-.415.31-.572.693-.351z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "M410.784 150.294v76.378c0 1.015.713 2.244 1.588 2.749l43.879 25.317c.182.104.364.156.526.151a.883.883 0 0 0 .339-.073 1.23 1.23 0 0 0 .083-.047l.094-.063c.031-.026.063-.047.088-.078.125-.115.219-.255.292-.417.104-.234.167-.51.167-.802v-75.993c0-1.01-.713-2.244-1.588-2.749l-43.879-25.29c-.411-.234-.781-.271-1.067-.135a.697.697 0 0 0-.135.078l-.01.01a.488.488 0 0 0-.104.104c-.021.016-.031.036-.047.057-.021.026-.042.052-.052.083a.722.722 0 0 0-.094.203.53.53 0 0 0-.036.141c-.005.01-.01.021-.005.031a1.61 1.61 0 0 0-.039.345z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M411.305 149.242c.286-.135.656-.099 1.067.135l43.879 25.29c.875.505 1.588 1.739 1.588 2.749v5.185l2.529-1.462v-5.149c0-1.01-.708-2.239-1.583-2.743l-43.884-25.291c-.453-.266-.859-.271-1.151-.094-.286.174-2.107 1.203-2.445 1.38z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M410.788 150.283c.006-1.002.713-1.407 1.585-.903l43.879 25.29c.876.506 1.586 1.736 1.586 2.747l-.002 5.188-47.048-27.116z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m412.373 149.379 43.876 25.29c.434.254.833.683 1.117 1.177l2.519-1.442c-.284-.489-.674-.914-1.103-1.158l-43.88-25.29c-.454-.264-.858-.268-1.152-.094a129.26 129.26 0 0 1-2.439 1.377c.279-.134.653-.094 1.062.14z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "m460.37 181.147-.001-5.156c0-.514-.188-1.082-.483-1.586l-2.524 1.437c.294.499.474 1.063.474 1.576v5.187z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "M455.531 176.803c.495.286.896 1.135.896 1.897s-.401 1.148-.896.862c-.495-.286-.896-1.135-.896-1.897 0-.761.401-1.148.896-.862zM452.304 174.937c.495.286.896 1.135.896 1.897s-.401 1.148-.896.862c-.495-.286-.896-1.135-.896-1.897s.402-1.148.896-.862zM449.078 173.071c.495.286.896 1.135.896 1.897s-.401 1.148-.896.862c-.495-.286-.896-1.135-.896-1.897s.401-1.148.896-.862z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M457.255 254.742c.057-.036.125-.073.198-.115.146-.089.313-.182.489-.276l.005-.005a7.138 7.138 0 0 1 .286-.161c.146-.083.286-.167.417-.24.135-.078.759-.42.852-.472.094-.057.167-.094.198-.109a.89.89 0 0 0 .271-.219c.083-.089.156-.198.214-.323.115-.239.182-.531.182-.838V181.14l-2.529 1.462v70.807a2.38 2.38 0 0 1-.167.802 1.265 1.265 0 0 1-.292.417.267.267 0 0 1-.088.078.103.103 0 0 1-.036.036z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M414.431 164.251c0-.095.027-.163.081-.203l1.14-1.043c.019-.012.036-.016.052-.01l.029.012c.034.02.064.056.09.11a.37.37 0 0 1 .038.159v.793a.743.743 0 0 1-.023.218.307.307 0 0 1-.081.123l-.602.553.602 1.247c.039.082.066.154.081.216.016.063.023.144.023.245v.793c0 .053-.013.092-.038.117-.025.024-.055.026-.09.006a.22.22 0 0 1-.081-.091l-1.14-2.36a.633.633 0 0 1-.081-.296zM418.602 163.15a.317.317 0 0 1 .086-.133c.039-.034.095-.03.168.012l.428.247c.035.02.065.057.09.11a.37.37 0 0 1 .037.159.276.276 0 0 1-.011.074l-1.955 6.077a.299.299 0 0 1-.081.131c-.039.037-.096.034-.173-.011l-.411-.237a.235.235 0 0 1-.09-.109.36.36 0 0 1-.038-.16.27.27 0 0 1 .011-.073zM421.628 168.994c0 .095-.027.162-.081.202l-1.14 1.043c-.019.013-.037.016-.052.01l-.029-.012a.238.238 0 0 1-.09-.11.37.37 0 0 1-.037-.16v-.793c0-.101.008-.174.023-.219a.318.318 0 0 1 .081-.123l.602-.552-.602-1.247a1.188 1.188 0 0 1-.081-.216 1.072 1.072 0 0 1-.023-.244v-.793c0-.053.012-.092.037-.117.025-.024.055-.026.09-.006a.22.22 0 0 1 .081.091l1.14 2.36a.633.633 0 0 1 .081.296zM424.798 172.107a.292.292 0 0 1 .11.135.453.453 0 0 1 .046.196v.873c0 .066-.016.112-.046.143-.031.029-.068.032-.11.007l-.538-.31a.298.298 0 0 1-.11-.134.456.456 0 0 1-.046-.196v-.873c0-.065.015-.113.046-.143.03-.03.067-.033.11-.008zM426.598 173.147a.294.294 0 0 1 .11.134.456.456 0 0 1 .046.196v.873c0 .066-.015.113-.046.143-.031.029-.068.032-.11.008l-.538-.311a.293.293 0 0 1-.11-.134.453.453 0 0 1-.046-.196v-.873c0-.065.015-.113.046-.143.031-.029.067-.033.11-.008zM428.397 174.185a.292.292 0 0 1 .11.135c.03.065.046.131.046.196v.873c0 .066-.016.112-.046.143-.031.029-.068.032-.11.007l-.538-.311a.298.298 0 0 1-.11-.134.453.453 0 0 1-.046-.196v-.873c0-.065.015-.113.046-.143.031-.03.067-.033.11-.008zM414.911 171.171l26.364 15.221c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-26.364-15.221c-.311-.18-.564-.599-.564-.936 0-.337.252-.465.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6"
    },
    d: "m423.37 190.706 26.364 15.221c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-26.364-15.221c-.311-.18-.564-.599-.564-.936 0-.337.252-.465.564-.285zM423.37 200.473l12.619 7.291c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-12.618-7.29c-.311-.18-.564-.599-.564-.936-.001-.338.251-.466.563-.286z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m443.459 187.653 10.504 6.042c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-10.504-6.042c-.311-.18-.564-.599-.564-.936 0-.337.253-.465.564-.285zM414.911 224.887l26.364 15.221c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-26.364-15.221c-.311-.18-.564-.599-.564-.936 0-.337.252-.465.564-.285zM443.459 241.369l10.504 6.042c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-10.504-6.042c-.311-.18-.564-.599-.564-.936.001-.337.253-.465.564-.285zM443.459 226.744l10.504 6.042c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-10.504-6.042c-.311-.18-.564-.599-.564-.936.001-.337.253-.465.564-.285zM443.459 231.627l10.504 6.042c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-10.504-6.042c-.311-.18-.564-.599-.564-.936.001-.337.253-.465.564-.285zM434.503 221.559l5.901 3.408c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-5.901-3.407c-.311-.18-.564-.599-.564-.936 0-.339.253-.466.564-.286zM414.911 176.066l15.378 8.872c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-15.378-8.872c-.311-.18-.564-.599-.564-.936 0-.337.252-.465.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m414.911 176.066 15.378 8.872c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-15.378-8.872c-.311-.18-.564-.599-.564-.936 0-.337.252-.465.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m414.911 180.94 5.217 3.008c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-5.217-3.008c-.311-.18-.564-.599-.564-.936 0-.337.252-.465.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m414.911 180.94 5.217 3.008c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-5.217-3.008c-.311-.18-.564-.599-.564-.936 0-.337.252-.465.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m414.911 185.824 5.217 3.008c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-5.217-3.008c-.311-.18-.564-.599-.564-.936 0-.337.252-.465.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m414.911 185.824 5.217 3.008c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-5.217-3.008c-.311-.18-.564-.599-.564-.936 0-.337.252-.465.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m414.911 190.707 5.217 3.008c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-5.217-3.008c-.311-.18-.564-.599-.564-.936 0-.337.252-.465.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m414.911 190.706 5.217 3.008c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-5.217-3.008c-.311-.18-.564-.599-.564-.936 0-.337.252-.465.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#27debf"
    },
    d: "m423.369 195.589 15.378 8.872c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-15.378-8.872c-.311-.18-.564-.599-.564-.936.001-.337.253-.464.564-.285zM440.931 205.722l6.687 3.873c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-6.687-3.873c-.311-.18-.564-.599-.564-.936.001-.337.253-.465.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m423.369 195.589 15.378 8.872c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-15.378-8.872c-.311-.18-.564-.599-.564-.936.001-.337.253-.464.564-.285zM440.931 205.722l6.687 3.873c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-6.687-3.873c-.311-.18-.564-.599-.564-.936.001-.337.253-.465.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m414.911 195.59 5.217 3.008c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-5.217-3.008c-.311-.18-.564-.599-.564-.936 0-.337.252-.464.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m414.911 195.59 5.217 3.008c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-5.217-3.008c-.311-.18-.564-.599-.564-.936 0-.337.252-.464.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m432.473 186.198 6.687 3.873c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-6.687-3.873c-.311-.18-.564-.599-.564-.936 0-.337.253-.464.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m432.473 186.198 6.687 3.873c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-6.687-3.873c-.311-.18-.564-.599-.564-.936 0-.337.253-.464.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m429.714 209.012 15.378 8.872c.311.18.563.599.563.936 0 .337-.252.465-.563.285l-15.378-8.872c-.311-.18-.564-.599-.564-.936 0-.337.253-.464.564-.285zM438.586 219.038l15.378 8.872c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-15.378-8.872c-.311-.18-.564-.599-.564-.936 0-.337.252-.465.564-.285zM447.276 219.145l6.687 3.873c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-6.687-3.873c-.311-.18-.564-.599-.564-.936 0-.337.253-.465.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6"
    },
    d: "m447.276 238.487 6.687 3.873c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-6.687-3.873c-.311-.18-.564-.599-.564-.936 0-.337.253-.464.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m423.369 185.824 15.378 8.872c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-15.378-8.872c-.311-.18-.564-.599-.564-.936.001-.337.253-.465.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m423.369 185.824 15.378 8.872c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-15.378-8.872c-.311-.18-.564-.599-.564-.936.001-.337.253-.465.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m440.931 195.956 6.687 3.873c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-6.687-3.873c-.311-.18-.564-.599-.564-.936.001-.337.253-.464.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#fff"
    },
    d: "m440.931 195.956 6.687 3.873c.311.18.564.599.564.936 0 .337-.252.465-.564.285l-6.687-3.873c-.311-.18-.564-.599-.564-.936.001-.337.253-.464.564-.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15
    },
    d: "m336.115 251.905 9.425 5.441c2.971 1.715 7.627 1.469 10.4-.549l15.545-11.351c2.774-2.018 2.616-5.048-.352-6.768l-4.726-2.738c-2.968-1.72-7.859-1.868-10.926-.331l-19.193 10.406c-3.065 1.539-3.143 4.175-.173 5.89z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "m371.744 240.515-10.757 8.409-7.937 6.21c-.77.36-1.652.559-2.534.609-1.341.075-2.708-.186-3.764-.795l-8.434-4.869s-.012 0-.012-.012l-.048-.028c-2.959-1.722-3.657-5.721-1.704-8.533a11.218 11.218 0 0 1 7.031-4.643l4.273-.857c6.919-1.404 12.595-2.087 13.253-1.64l10.57 6.124c.026 0 .051.012.063.025z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m365.731 245.218.604-.473-9.485-5.476 8.3-2.569-.839-.485-8.3 2.569-5.656-3.266c-.352.065-.711.133-1.072.203z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M353.982 254.625c.012-.012.037-.025.05-.037 0-.013.013-.013.013-.013l7.552-5.453 10.198-7.366v-1.155c0-.037-.013-.062-.05-.087a.096.096 0 0 0-.062-.025c-.758-.261-5.18 1.068-10.521 3.192l-3.54 1.404a11.008 11.008 0 0 0-3.018 1.789 11.252 11.252 0 0 0-4.087 8.682v.186c.882-.05 1.764-.249 2.534-.609z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M372.699 405.512c-10.378-10.708-16.474-54.288-6.352-62.782h51.503c10.12 8.491 4.03 52.056-6.341 62.771-.089.1-.191.196-.284.295-.119.119-.237.239-.357.353-.293.287-.604.568-.938.844-.082.069-.165.13-.248.197-.254.201-.505.404-.783.598a14.58 14.58 0 0 1-1.341.867c-8.537 4.984-22.377 4.984-30.913 0h-.002a14.792 14.792 0 0 1-1.351-.873c-.258-.181-.491-.37-.729-.557-.102-.082-.205-.158-.307-.243a14.42 14.42 0 0 1-.905-.814c-.139-.132-.276-.27-.412-.408-.079-.083-.166-.164-.24-.248z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M372.699 405.512c-10.378-10.708-16.474-54.288-6.352-62.782h51.503c10.12 8.491 4.03 52.056-6.341 62.771-.089.1-.191.196-.284.295-.119.119-.237.239-.357.353-.293.287-.604.568-.938.844-.082.069-.165.13-.248.197-.254.201-.505.404-.783.598a14.58 14.58 0 0 1-1.341.867c-8.537 4.984-22.377 4.984-30.913 0h-.002a14.792 14.792 0 0 1-1.351-.873c-.258-.181-.491-.37-.729-.557-.102-.082-.205-.158-.307-.243a14.42 14.42 0 0 1-.905-.814c-.139-.132-.276-.27-.412-.408-.079-.083-.166-.164-.24-.248z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M413.378 339.31c11.751 6.861 11.751 17.985 0 24.846-11.752 6.861-30.804 6.861-42.555 0-11.751-6.861-11.751-17.985.001-24.845 11.75-6.862 30.802-6.862 42.554-.001z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M413.378 339.31c11.751 6.861 11.751 17.985 0 24.846-11.752 6.861-30.804 6.861-42.555 0-11.751-6.861-11.751-17.985.001-24.845 11.75-6.862 30.802-6.862 42.554-.001z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M407.726 342.609c8.63 5.039 8.63 13.208 0 18.246-8.63 5.038-22.622 5.039-31.252 0-8.63-5.038-8.63-13.207 0-18.246 8.63-5.038 22.622-5.038 31.252 0z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.726 342.609c8.63 5.039 8.63 13.208 0 18.246-8.63 5.038-22.622 5.039-31.252 0-8.63-5.038-8.63-13.207 0-18.246 8.63-5.038 22.622-5.038 31.252 0z",
    transform: "matrix(-1 0 0 1 499.72 0)",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5"
    },
    d: "M376.474 351.269c8.63-5.039 22.621-5.039 31.251 0 2.397 1.4 4.103 3.045 5.169 4.793-1.066 1.748-2.772 3.393-5.169 4.793-8.63 5.038-22.622 5.038-31.251 0-2.397-1.4-4.104-3.045-5.169-4.793 1.065-1.748 2.772-3.393 5.169-4.793z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M387.881 329.277c-.576-1.171-1.062-2.388-1.314-3.758-.577-3.137.205-6.734 2.744-8.665 1.01-.769 2.325-1.338 2.755-2.533.237-.658.147-1.385.026-2.074-.472-2.678-1.376-5.436-.631-8.052.689-2.42 2.722-4.275 4.995-5.353 2.273-1.079 4.795-1.492 7.278-1.901 1.324-.218 2.677-.449 3.848-1.104 1.439-.805 1.886-2.227 2.783-3.475.987-1.375 2.272-2.648 3.53-3.772 2.622-2.344 5.908-4.272 9.539-4.111 7.575.335 7.361 6.853 5.174 11.795-2.187 4.942-2.762 6.55 1.97 11.698 4.732 5.148 4.743 11.493-.903 15.048-5.646 3.555-9.321 4.022-7.086 10.863 1.996 6.107 3.232 11.322-2.413 17.85-3.648 4.219-8.636 7.23-14.877 6.974-1.769-.073-5.656-.887-7.298-1.702-1.718-.854-.56-2.189-1.141-3.884l-3.741-10.924c-.965-2.818-1.7-5.945-2.975-8.615-.713-1.5-1.556-2.868-2.263-4.305z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.881 329.277c-.576-1.171-1.062-2.388-1.314-3.758-.577-3.137.205-6.734 2.744-8.665 1.01-.769 2.325-1.338 2.755-2.533.237-.658.147-1.385.026-2.074-.472-2.678-1.376-5.436-.631-8.052.689-2.42 2.722-4.275 4.995-5.353 2.273-1.079 4.795-1.492 7.278-1.901 1.324-.218 2.677-.449 3.848-1.104 1.439-.805 1.886-2.227 2.783-3.475.987-1.375 2.272-2.648 3.53-3.772 2.622-2.344 5.908-4.272 9.539-4.111 7.575.335 7.361 6.853 5.174 11.795-2.187 4.942-2.762 6.55 1.97 11.698 4.732 5.148 4.743 11.493-.903 15.048-5.646 3.555-9.321 4.022-7.086 10.863 1.996 6.107 3.232 11.322-2.413 17.85-3.648 4.219-8.636 7.23-14.877 6.974-1.769-.073-5.656-.887-7.298-1.702-1.718-.854-.56-2.189-1.141-3.884l-3.741-10.924c-.965-2.818-1.7-5.945-2.975-8.615-.713-1.5-1.556-2.868-2.263-4.305z",
    transform: "matrix(-1 0 0 1 499.72 0)",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M398.18 356.974a.563.563 0 0 0 .375-.537c-.32-37.417 20.303-59.757 20.511-59.978a.569.569 0 0 0-.02-.797.551.551 0 0 0-.788.018c-.212.224-21.142 22.871-20.817 60.765a.56.56 0 0 0 .739.529z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M404.182 322.169a.557.557 0 0 0 .113-.054c6.71-4.223 18.686-7.373 18.805-7.407a.561.561 0 0 0 .4-.686.557.557 0 0 0-.68-.405c-.498.128-12.261 3.227-19.115 7.54a.566.566 0 0 0-.178.776c.141.228.415.32.655.236zM406.255 317.039a.563.563 0 0 0 .333-.746c-2.349-5.801-6.034-10.226-6.19-10.412a.553.553 0 0 0-.786-.066.568.568 0 0 0-.064.795c.037.044 3.728 4.479 6.008 10.107.114.28.422.419.699.322z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M392.922 361.027s-7.002 2.65-16.428.608c-9.426-2.042-15.192-10.843-15.192-10.843s10.195-4.085 16.141-4.481c0 0-9.225-1.573-17.857.383 0 0-5.456-2.032-4.423-11.246 0 0 5.135-3.785 16.957-2.302 0 0-5.924-4.228-16.308-5.476-.817.008.289-11.995 1.279-17.345s2.955-4.524 7.201-4.062c4.246.462 16.806 3.32 18.4 6.401 1.594 3.081.045 10.935.045 10.935s3.452-4.296 3.466-10.279c0 0 4.727 1.728 7.254 3.96 2.527 2.232 3.791 4.035 4.521 5.66-.59 4.212-2.572 10.638-5.351 14.228 0 0 6.261-4.042 7.693-11.49 0 0 5.007 6.395 4.958 14.653-.057 9.415-4.244 16.405-12.356 20.696z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M392.922 361.027s-7.002 2.65-16.428.608c-9.426-2.042-15.192-10.843-15.192-10.843s10.195-4.085 16.141-4.481c0 0-9.225-1.573-17.857.383 0 0-5.456-2.032-4.423-11.246 0 0 5.135-3.785 16.957-2.302 0 0-5.924-4.228-16.308-5.476-.817.008.289-11.995 1.279-17.345s2.955-4.524 7.201-4.062c4.246.462 16.806 3.32 18.4 6.401 1.594 3.081.045 10.935.045 10.935s3.452-4.296 3.466-10.279c0 0 4.727 1.728 7.254 3.96 2.527 2.232 3.791 4.035 4.521 5.66-.59 4.212-2.572 10.638-5.351 14.228 0 0 6.261-4.042 7.693-11.49 0 0 5.007 6.395 4.958 14.653-.057 9.415-4.244 16.405-12.356 20.696z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M394.168 360.19a.54.54 0 0 1-.341-.461c-1.426-17.856-21.404-45.75-30.235-51.35a.546.546 0 0 1-.169-.747.536.536 0 0 1 .739-.171c8.976 5.693 29.285 34.04 30.732 52.181a.539.539 0 0 1-.49.583.545.545 0 0 1-.236-.035z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa8a7"
    },
    d: "M213.491 349.026c-.036-.2-3.21-11.793-3.21-11.793s1.045 1.067 7.749-.702c3.41-.9 7.29-3.059 7.29-3.059l1.914 8.475c1.785 3.263 7.704 1.76 14.188 1.022 1.09-.124 2.21-.307 3.331-.5l.068-.008c3.501-.192 7.016 1.911 3.376 4.896-3.64 2.986-9.644 4.117-15.179 5.116-6.658 1.204-18.334 3.159-19.527-3.447z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M260.039 347.999s.702 1.342.484 3.562c-.127 1.292-3.32 5.673-8.961 8.355-5.64 2.681-12.62 2.862-15.887 3.802-3.266.94-6.259 2.816-10.108 3.753-3.967.966-7.656 1.434-11.514-1.106-.71-1.096-1.498-3.628-1.27-3.874.615-.663 47.256-14.492 47.256-14.492z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M228.252 343.076c2.483 1.717 7.62.525 13.171-.107 5.234-.596 11.127-2.435 14.685-1.202 3.557 1.234 6.532 5.422 1.724 10.791-1.391 1.553-4.335 4.286-6.687 5.128-5.977 2.14-11.34 2.313-15.185 3.262-5.002 1.235-7.736 3.45-12.364 3.987-5.988.695-9.776-.844-10.812-2.443-1.035-1.599-1.997-14.49.57-14.223 0 0 1.08 4.172 10.861.12 4.271-1.77 4.203-4.374 4.037-5.313z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M228.252 343.076c2.483 1.717 7.62.525 13.171-.107 5.234-.596 11.127-2.435 14.685-1.202 3.557 1.234 6.532 5.422 1.724 10.791-1.391 1.553-4.335 4.286-6.687 5.128-5.977 2.14-11.34 2.313-15.185 3.262-5.002 1.235-7.736 3.45-12.364 3.987-5.988.695-9.776-.844-10.812-2.443-1.035-1.599-1.997-14.49.57-14.223 0 0 1.08 4.172 10.861.12 4.271-1.77 4.203-4.374 4.037-5.313z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa"
    },
    d: "M244.851 349.994s-.562-5.445-4.585-6.886c0 0-1.296-.595-2.217.292 0 0 3.734.542 4.957 6.928 0 0 .192.422 1.005.275.276-.051.879-.159.84-.609zM234.619 343.823s-.005-.18.945-.358c.684-.128 1.103.121 1.103.121s3.001 1.299 3.562 6.991c0 0-.024.686-.924.875-.9.189-1.073-.557-1.073-.557s-.618-5.988-3.613-7.072zM231.399 343.941s.168-.343.874-.339c.891.005 1.096.349 1.096.349s2.137 2.19 2.161 6.945c0 0 .089.806-1.032.888-1.12.082-.96-.828-.96-.828s-.386-6.059-2.139-7.015z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M209.35 270.196c4.902 14.731 17.902 65.458 17.902 65.458s-8.46 7.601-17.639 4.138l-21.867-63.167z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa8a7"
    },
    d: "M247.139 365.402c-1.001-1.487-4.76-11.804-4.76-11.804s3.925 2.242 10.671.639c3.431-.816 6.637-4.541 6.637-4.541l2.881 9.918c1.704 3.305 7.208 2.212 13.709 1.633a59.701 59.701 0 0 0 3.343-.418l.068-.006c3.505-.106 6.967 2.082 3.254 4.978-3.712 2.896-9.742 3.879-15.3 4.742-6.686 1.039-16.754.426-20.503-5.141z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M297.56 365.091s.719 1.46.427 3.837c-.17 1.384-3.714 6.003-9.84 8.733-6.126 2.73-13.624 2.74-17.156 3.663-3.532.923-6.794 2.859-10.951 3.763-4.284.932-8.257 1.338-12.332-1.491-.733-1.196-1.513-3.934-1.261-4.193.676-.696 51.113-14.312 51.113-14.312z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M263.628 358.872c.401.273.807.545 1.228.762.444.227.873.217 1.365.276 1.089.131 2.18.137 3.275.083 2.746-.136 5.473-.55 8.21-.794 5.634-.502 12.01-2.321 15.797-.903 3.787 1.418 7.244 5.976 1.941 11.614-1.534 1.63-4.691 4.38-7.107 5.391-6.29 2.631-12.816 2.139-16.969 3.056-5.403 1.194-8.396 3.499-13.378 3.954-6.447.588-10.473-1.164-11.543-2.908-.597-.973.067-6.027-.741-9.953-.696-3.38-.513-5.683.702-5.526.191.436.642.828.941 1.194.39.477.883.85 1.43 1.131.759.388 1.592.605 2.419.814 1.472.372 2.977.733 4.49.617.432-.033.883-.115 1.22-.388.444-.36.59-.965.709-1.525l.317-1.491c.058-.27.118-.548.272-.778.183-.273.478-.448.766-.608.908-.507 1.883-1.003 2.456-1.872.448-.68.594-1.51.72-2.314.022-.14.051-.293.162-.38.184-.146.451-.022.65.104.222.14.445.292.668.444z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M263.628 358.872c.401.273.807.545 1.228.762.444.227.873.217 1.365.276 1.089.131 2.18.137 3.275.083 2.746-.136 5.473-.55 8.21-.794 5.634-.502 12.01-2.321 15.797-.903 3.787 1.418 7.244 5.976 1.941 11.614-1.534 1.63-4.691 4.38-7.107 5.391-6.29 2.631-12.816 2.139-16.969 3.056-5.403 1.194-8.396 3.499-13.378 3.954-6.447.588-10.473-1.164-11.543-2.908-.597-.973.067-6.027-.741-9.953-.696-3.38-.513-5.683.702-5.526.191.436.642.828.941 1.194.39.477.883.85 1.43 1.131.759.388 1.592.605 2.419.814 1.472.372 2.977.733 4.49.617.432-.033.883-.115 1.22-.388.444-.36.59-.965.709-1.525l.317-1.491c.058-.27.118-.548.272-.778.183-.273.478-.448.766-.608.908-.507 1.883-1.003 2.456-1.872.448-.68.594-1.51.72-2.314.022-.14.051-.293.162-.38.184-.146.451-.022.65.104.222.14.445.292.668.444z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa"
    },
    d: "M281.202 366.832s-.459-5.86-4.74-7.513c0 0-1.376-.673-2.388.254 0 0 3.995.68 5.139 7.568 0 0 .195.458 1.072.321.297-.046.947-.147.917-.63zM270.38 359.938s-.001-.194 1.024-.359c.737-.119 1.181.159 1.181.159s3.188 1.474 3.64 7.599c0 0-.044.736-1.015.915-.971.179-1.137-.626-1.137-.626s-.506-6.446-3.693-7.688zM266.92 359.979s.19-.364.948-.341c.956.029 1.167.404 1.167.404s2.236 2.407 2.137 7.513c0 0 .074.868-1.131.926-1.205.058-1.009-.915-1.009-.915s-.256-6.515-2.112-7.587z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "M243.842 287.59c3.859 11.87 13.714 45.664 18.216 63.044 0 0-8.09 7.275-18.497 6.64l-25.092-65.064 9.993-6.184zM161.23 450.026c.899 0 1.627-.728 1.627-1.627v-104.59a1.626 1.626 0 1 0-3.254 0V448.4c0 .899.727 1.626 1.627 1.626zM96.519 411.957c.648 0 1.26-.389 1.512-1.03l32.072-81.177a1.625 1.625 0 0 0-.915-2.11 1.623 1.623 0 0 0-2.11.915l-32.072 81.177a1.626 1.626 0 0 0 1.513 2.225z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "M100.371 402.207c.432 0 .863-.172 1.182-.51l59.678-63.151 59.57 62.884a1.621 1.621 0 0 0 2.299.062c.653-.618.68-1.648.062-2.299L162.41 335.06a1.627 1.627 0 0 0-1.18-.508h-.002c-.447 0-.874.184-1.18.51L99.19 399.463a1.625 1.625 0 0 0 1.181 2.744z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "M225.939 411.957a1.624 1.624 0 0 0 1.512-2.225l-32.072-81.177a1.622 1.622 0 0 0-2.11-.915 1.624 1.624 0 0 0-.915 2.11l32.072 81.177c.253.641.865 1.03 1.513 1.03z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M226.724 307.94c1.167-6.56-4.178-11.68-14.234-18.467-10.055-6.786-22.912-13.513-29.135-16.369-8.412-3.861-17.018-3.506-27.788 2.028-14.963 7.688-59.991 34.994-59.991 34.994s67.32 38.006 80.272 36.302c12.953-1.704 45.326-22.756 47.891-30.166 2.565-7.41 2.985-8.322 2.985-8.322z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.724 307.94c1.167-6.56-4.178-11.68-14.234-18.467-10.055-6.786-22.912-13.513-29.135-16.369-8.412-3.861-17.018-3.506-27.788 2.028-14.963 7.688-59.991 34.994-59.991 34.994s67.32 38.006 80.272 36.302c12.953-1.704 45.326-22.756 47.891-30.166 2.565-7.41 2.985-8.322 2.985-8.322z",
    transform: "matrix(-1 0 0 1 499.72 0)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M169.345 338.434c9.664 8.749 19.766 1.219 35.747-9.152 18.086-11.737 21.632-21.342 21.632-21.342s0 7.196-1.349 10.569c-1.349 3.373-4.273 7.196-17.316 16.192-13.043 8.995-22.488 13.493-31.259 15.163l-6.919-.956",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M205.092 329.282c18.086-11.737 21.632-21.342 21.632-21.342s0 7.196-1.349 10.569c-1.349 3.373-4.272 7.196-17.316 16.192-13.043 8.995-22.488 13.493-31.259 15.163l-6.919-.956-.536-10.474c9.664 8.749 19.766 1.219 35.747-9.152z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m99.041 399.218-4.955 11.422a1.168 1.168 0 0 0-.054.296c-.01.066-.013.138-.01.211.029.24.315.558.63.765.72.464 1.922.521 2.682.126.278-.146.459-.329.548-.524 0-.007.001-.013.007-.019l.04-.157 4.599-10.711zM223.728 399.699l4.24 11.19c.025.095.038.191.038.286.006.063.006.133 0 .203-.038.229-.327.521-.639.706-.712.413-1.869.413-2.581 0-.261-.152-.426-.337-.502-.528 0-.006 0-.013-.006-.019l-.032-.153-3.931-10.49zM159.353 440.302v9.256c0 .277.183.554.549.766.732.423 1.92.423 2.652 0 .366-.211.549-.489.549-.766v-9.256c-1.249-.627-2.499-.627-3.75 0z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M122.538 268.722c3.834 4.466 38.725-5.572 47.967-6.831 14.908-2.031 27.045-3.515 32.103-1.924 5.058 1.59 7.209 4.169 8.76 10.229 1.829 7.148 2.776 10.79 2.776 10.79s-24.77 9.508-44.302 11.797c-19.531 2.289-47.304-24.061-47.304-24.061z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64"
    },
    d: "M116.029 275.27c-3.868 14.735-7.343 31.879 1.609 41.265 6.028 6.32 36.312 22.737 55.85 16.269 19.247-6.371 59.1-35.959 63.099-38.938 4.008-2.986 7.637-5.009 7.255-6.276-5.375-17.843-13.229-19.237-27.796-16.032-17.812 3.918-56.919 19.878-56.919 19.878z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa8a7"
    },
    d: "m191.083 195.713-21.704-10.298 15.173-20.994 19.968 16.098z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 499.72 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f28f8f"
    },
    d: "M221.19 151.659s5.501 7.945 4.913 8.751c-.588.806-4.483 1.611-4.483 1.611z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.207,
      strokeMiterlimit: 10
    },
    cx: 221.147,
    cy: 150.328,
    r: 5.975
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa8a7"
    },
    d: "M205.918 129.682c10.81 2.023 14.024 6.681 15.429 23.747 1.468 17.833-.227 23.487-2.517 25.946-1.547 1.658-10.34 2.153-14.808 1.031-5.592-1.405-18.25-5.567-24.337-14.415-7.159-10.41-9.305-24.69-2.033-30.735 10.233-8.507 23.867-6.397 28.266-5.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f28f8f"
    },
    d: "M204.52 180.519c4.652 1.051 11.726.416 13.827-.79-.199.054-3.529.915-7.824-.288-4.43-1.241-7.168-3.16-7.168-3.16z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "m223.349 136.666-.031.021c-3.017 2.081-6.698 2.947-10.32 3.51.286 2.894-.626 5.758-1.526 8.523-.623 1.914-2.871 7.925-5.319 4.625-1.768-2.384-3.376-4.554-6.762-3.97-5.581.964-6.173 8.119-2.546 12.374 3.629 4.255 6.88 2.518 6.88 2.518s.514 7.692-3.542 13.129c0 0-6.055 3.722-14.553.921-5.363-1.767-13.103-8.529-15.955-13.807-7.85-14.525-7.89-28.44 1.63-32.721.881-6.962 6.272-10.198 12.467-11.771 8.586-2.181 17.508 3.206 25.81-.35 1.748-.749 3.358-1.81 5.146-2.459 1.005-.365 2.195-.574 3.09.011.774.506 1.105 1.462 1.321 2.361.396 1.653.549 3.501-.326 4.958 1.253-.604 2.529-1.214 3.902-1.438 1.373-.223 2.883-.008 3.945.889.988.835 1.463 2.15 1.583 3.438.34 3.64-1.892 7.155-4.894 9.238z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "m171.193 134.117-6.525-3.648a3.738 3.738 0 0 1 6.525 3.648z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 1.027,
      strokeMiterlimit: 10
    },
    d: "m206.153 153.345 20.902-3.906",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa8a7"
    },
    d: "M249.861 189.397c-.563-.942-1.813-1.125-2.849-1.486-1.921-.67-3.421-2.202-5.27-3.048-2.06-.943-4.453-.974-6.657-.45-.759.181-1.5.423-2.224.711-1.378.547-2.696 1.258-3.974 2.014-5.296 3.135-9.277 10.221-14.484 13.472-1.94 1.212-3.753 2.312-5.539 3.407l12.437 11.088c2.562-2.084 5.007-4 6.135-4.671 3.062-1.822 6.151-1.863 9.591-2.362 2.388-.346 4.706-1.052 7.014-1.756.813-.248 1.718-.574 2.066-1.348.442-.982-.332-2.165-1.334-2.56-1.073-.423-2.485-.313-3.636-.498-.895-.144-3.295.394-3.827-.513-.278-.474.067-1.059.41-1.488 2.157-2.69 4.885-5.572 8.338-6.38 1.071-.251 2.187-.508 3.037-1.205.85-.698 1.33-1.984.766-2.927z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M175.466 176.992c-13.209-7.208-25.237-2.579-29.571 6.69-3.921 8.388-12.165 40.844-12.165 40.844 3.962 7.43 41.736-47.534 41.736-47.534z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "m173.488 179.6 1.978-2.607c-14.913-7.086-28.266 2.223-40.027 20.516-12.676 19.718-19.328 48.03-19.392 77.91 0 0 2.53 13.427 19.497 20.145 18 7.126 43.11 4.107 50.933-14.551 0 0 .158-18.635 5.826-27.811 3.667-5.937 12.219-19.135 18.581-28.6 5.538-8.239 9.842-26.99-1.729-33.85-3.388-2.009-4.794-2.595-9.407-4.8-10.526 3.475-27.618-2.173-26.26-6.352z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75,
      fill: "#fff"
    },
    d: "m173.533 179.667 1.933-2.674c-14.913-7.086-28.266 2.223-40.027 20.516-12.676 19.718-19.328 48.03-19.392 77.91 0 0 2.53 13.427 19.497 20.145 18 7.126 43.11 4.107 50.933-14.551 0 0 .158-18.635 5.826-27.811 3.667-5.937 12.219-19.135 18.581-28.6 5.538-8.239 9.842-26.99-1.729-33.85-3.388-2.009-4.794-2.595-9.407-4.8-10.526 3.475-27.573-2.106-26.215-6.285z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#27debf"
    },
    d: "M215.699 212.653c.764-3.592 1.024-7.373.464-10.86-2.705 6.336-6.518 12.202-11.262 17.199-6.069 6.392-13.564 11.37-19.195 18.151-5.963 7.182-10.25 15.866-15.243 23.711-2.004 3.148-4.74 9.22-8.464 9.463-4.539.295-8.878-5.237-11.353-9.053-3.949-6.088-7.34-13.692-12.249-19.035-4.29-4.669-10.925-10.65-16.769-7.94a145.099 145.099 0 0 0-2.365 9.72 150.01 150.01 0 0 0-.927 4.884l-.044.261a156.236 156.236 0 0 0-.752 4.861 159.16 159.16 0 0 0-1.491 21.405s2.531 13.427 19.497 20.145c18 7.126 43.11 4.107 50.934-14.551 0 0 .157-18.635 5.826-27.811a377.9 377.9 0 0 1 2.054-3.28l.133-.209a767.456 767.456 0 0 1 2.107-3.308l.138-.217.058-.089a1246.74 1246.74 0 0 1 6.17-9.528c1.815-2.777 3.665-5.586 5.428-8.239l.019-.028c.596-.896 1.175-1.764 1.746-2.616.244-.364.49-.733.729-1.087l.005-.008c.2-.298.397-.612.593-.935.059-.097.117-.198.175-.298a28.513 28.513 0 0 0 1.05-1.96c.038-.077.076-.151.113-.229.188-.392.373-.795.552-1.208l.02-.048.03-.072c.16-.372.315-.752.466-1.139l.106-.278c.139-.366.275-.737.405-1.114l.031-.088.043-.124c.237-.696.457-1.409.659-2.135l.005-.016a38.53 38.53 0 0 0 .546-2.216l.004-.02a.223.223 0 0 1 .008-.061z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa8a7"
    },
    d: "M284.891 230.802c-.93 1.154-1.999 2.203-3.099 3.2-4.562 4.132-9.893 6.114-16.089 10.138-5.009 3.253-12.733 7.991-19.242 12.048-7.316 4.561-16.139 8.268-20.952 9.682-6.048 1.777-9.432 1.852-13.008-7.835-1.754-4.75-3.143-9.625-4.657-14.457a2112.446 2112.446 0 0 1-6.643-21.61s-8.042-19.829 9.95-29.788c7.829 4.48 10.812 6.294 13.268 15.671 2.936 11.226 7.696 33.384 7.696 33.384 6.364-2.197 12.57-4.919 18.596-7.915 2.283-1.135 5.09-1.923 6.719-3.954 1.107-1.38 2.005-2.909 2.861-4.453.766-1.382 1.32-2.885 2.164-4.206 1.567-2.452 3.829-4.512 5.913-6.513.408-.392.865-.807 1.43-.847.596-.043 1.154.367 1.451.885.663 1.154.047 2.287-.292 3.468l-1.159 4.04c4.595-2.721 8.491-6.296 11.477-10.76.272-.406.54-.823.905-1.147.366-.324.85-.549 1.335-.489 1.205.15 2.398 2.094 2.458 3.205.061 1.131-.191 2.289.089 3.387.267 1.046.976 1.904 1.304 2.925.321.999.577 2.189.686 3.238.252 2.432-.606 4.723-1.826 6.786a15.627 15.627 0 0 1-1.335 1.917z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M210.076 191.35c6.858 2.772 11.793 5.903 14.919 16.361 3.143 10.517 6.516 27.241 6.516 27.241s.064 3.51-8.258 8.417-16.108 2.171-16.108 2.171l-6.285-20.197c-.001-.001-11.143-27.014 9.216-33.993zM169.881 348.908c-5.503-.277-9.81-4.317-22.895-9.769-24.16-10.067-42.28-18.12-49.183-30.775-6.903-12.656-11.793-49.184-10.067-65.003.229-2.099.637-3.824 1.183-5.244l-1.699-.249 4.401-3.746.002.011c4.514-3.687 11.861-.4 17.397 2.613 15.817 8.608 28.187 16.97 37.966 47.17 7.356 22.716 12.207 43.438 22.359 54.519",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "m88.919 238.117-1.699-.249 4.401-3.746.002.011c4.514-3.687 11.861-.4 17.397 2.613 15.817 8.608 28.187 16.97 37.966 47.17 7.356 22.716 12.207 43.438 22.359 54.519l.536 10.474c-5.503-.277-9.81-4.317-22.895-9.769-24.16-10.067-42.28-18.12-49.183-30.775-6.903-12.657-11.793-49.185-10.067-65.004.229-2.099.637-3.824 1.183-5.244z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M104.436 240.635c15.817 8.608 28.187 16.97 37.966 47.17 9.779 30.2 15.128 56.882 34.398 62.059 0 0-8.713 3.463-35.415-7.831-8.496-3.593-18.805-10.145-25.579-13.946-13.271-7.448-21.316-13.551-22.588-15.834-7.015-12.594-11.793-49.183-10.067-65.002 1.727-15.819 13.364-10.927 21.285-6.616zM193.338 106.694l-4.369-8.215 3.515-10.146v-6.211l-10.757 6.211v6.211l4.625 8.01c.078.135.19.224.314.279l-.003.004z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "m193.338 106.694-4.369-8.215 3.515-10.146v-6.211l-10.757 6.211v6.211l4.625 8.01c.078.135.19.224.314.279l-.003.004z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27debf"
    },
    d: "M219.027 32.749c0-2.057-1.444-4.558-3.225-5.586l-2.626-1.516c-1.781-1.028-4.669-1.028-6.45 0L166.453 48.94c-1.781 1.029-3.225 3.529-3.225 5.586v44.311c0 2.057 1.445 4.558 3.225 5.587l2.626 1.516c1.781 1.028 4.669 1.028 6.451 0l12.952-7.483 4.615 7.994a.689.689 0 0 0 1.247-.119l4.878-14.081 16.58-9.605c1.781-1.028 3.225-3.529 3.225-5.586z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M163.228 98.837c0 2.057 1.444 4.558 3.225 5.586l2.626 1.516c1.61.929 4.115 1.01 5.899.26-1.518.574-2.674-.283-2.674-2.122l-.001-44.312c0-1.028.361-2.168.944-3.179l-9.076-5.24c-.584 1.011-.944 2.15-.944 3.179v44.312z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#fff"
    },
    d: "M218.922 31.832c-.376-1.369-1.625-1.806-3.114-.948l-40.28 23.298c-.888.512-1.7 1.384-2.272 2.407l-9.073-5.236c.587-1.023 1.384-1.896 2.272-2.408l40.265-23.299c1.79-1.023 4.679-1.023 6.455 0l2.633 1.52c1.519.875 2.798 2.83 3.114 4.666z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M178.225 77.165c0-.359.056-.666.165-.92.109-.254.266-.541.47-.861l8.756-14.156a1.32 1.32 0 0 1 .142-.167.633.633 0 0 1 .099-.073c.131-.076.24-.072.327.013.088.084.132.228.132.43v5.46c0 .449-.085.828-.252 1.139-.168.311-.317.56-.448.748l-4.515 6.886 4.515 2.075c.131.037.281.109.448.214.168.105.252.383.252.832v3.878c0 .202-.044.396-.132.582-.087.185-.196.315-.327.391a.456.456 0 0 1-.099.04.299.299 0 0 1-.142-.003l-8.756-4.044a1.2 1.2 0 0 1-.47-.318c-.109-.127-.165-.37-.165-.73zM197.313 55.297c.073-.288.182-.582.328-.88.146-.298.358-.526.636-.687l2.933-1.694c.131-.076.244-.067.339.023.094.091.142.237.142.44 0 .091-.015.2-.044.33l-7.399 31.535a4.038 4.038 0 0 1-.306.851 1.595 1.595 0 0 1-.656.717l-2.868 1.656c-.13.075-.244.067-.338-.024-.096-.092-.143-.238-.143-.44 0-.089.015-.2.045-.328zM213.403 60.399c0 .36-.055.667-.164.92-.11.254-.267.542-.471.862l-8.756 14.154a1.08 1.08 0 0 1-.142.167.599.599 0 0 1-.098.074c-.132.076-.241.072-.328-.013-.088-.084-.131-.228-.131-.43v-5.46c0-.449.083-.824.251-1.122.168-.299.318-.544.448-.732l3.831-5.919-3.831-1.461a1.551 1.551 0 0 1-.448-.23c-.168-.118-.251-.4-.251-.849v-5.459c0-.202.043-.396.131-.582.087-.185.196-.315.328-.391a.412.412 0 0 1 .098-.041.359.359 0 0 1 .142.002l8.756 4.045c.205.084.361.189.471.317.109.128.164.372.164.73z",
    transform: "matrix(-1 0 0 1 499.72 0)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.5cc5a2bc2f97dd4ee5fb6ac801cefcfd.svg";
export { ForwardRef as ReactComponent };